import DialogManager from '~/Components/Dialog/DialogManager';
import Nav from '~/Components/Nav/Nav';
import RouteContent from '~/Components/RouteContent/RouteContent';

import styles from './View.scss';

const View = () => {
    return (
        <div className={styles.app}>
            <DialogManager />
            <Nav />
            <RouteContent />
        </div>
    );
};

export default View;
